import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import Login from '../pages/Login';
import Works from '../pages/Register/Works';
import Clients from '../pages/Register/Clients';
import Contributors from '../pages/Register/Contributors';

import Agents from '../pages/Register/Agents';
import Phonograms from '../pages/Register/Phonograms';
import Labels from '../pages/Register/Labels';
import Publishers from '../pages/Register/Publishers';
import Conexo from '../pages/Files/Conexo';
import Autoral from '../pages/Files/Autoral';
import ReportGraph from '../pages/ReportGraph';
import Reports from '../pages/Reports';
import TracksDashboard from '../pages/Dashboard/Tracks';
import WorksDashboard from '../pages/Dashboard/Works';
import Users from '../pages/Admin/Users';
import ReportModels from '../pages/Admin/ReportModels';

import Distributions from '../pages/Distributions';
import SessionContext, { SessionProvider } from '../contexts/SessionContext';

//Users access /Main if it provides a token, otherwise will be redirected for the login page.

const PrivateRoute = ({ component: Component }) => {
  let sessionContext = React.useContext(SessionContext);
  const location = useLocation();

  return sessionContext.session_data ? (
    <Component />
  ) : (
    <Navigate
      to="/"
      state={{ from: location.pathname + location.search }}
      replace
    />
  );
};

const Navigation = () => (
  <SessionProvider>
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route
          path="/register/works"
          element={<PrivateRoute component={Works} />}
        />
        <Route
          path="/register/holders"
          element={<PrivateRoute component={Contributors} />}
        />
        <Route
          path="/register/tracks"
          element={<PrivateRoute component={Phonograms} />}
        />
        <Route
          path="/register/labels"
          element={<PrivateRoute component={Labels} />}
        />
        <Route
          path="/register/publishers"
          element={<PrivateRoute component={Publishers} />}
        />
        <Route
          path="/register/clients"
          element={<PrivateRoute component={Clients} />}
        />
        <Route
          path="/register/agents"
          element={<PrivateRoute component={Agents} />}
        />
        <Route
          path="/files/Neighboring_Rights"
          element={<PrivateRoute component={Conexo} />}
        />
        <Route
          path="/files/copyright"
          element={<PrivateRoute component={Autoral} />}
        />
        <Route
          path="/distributions"
          element={<PrivateRoute component={Distributions} />}
        />
        <Route
          path="/reports"
          element={<PrivateRoute component={Reports} />}
        />
        <Route
          path="/graphs"
          element={<PrivateRoute component={ReportGraph} />}
        />
        <Route
          path="/admin/users"
          element={<PrivateRoute component={Users} />}
        />
        <Route
          path="/admin/ReportModels"
          element={<PrivateRoute component={ReportModels} />}
        />
        <Route
          path="/dashboard/neighboring_rights"
          element={<PrivateRoute component={TracksDashboard} />}
        />
        <Route
          path="/dashboard/copyright"
          element={<PrivateRoute component={WorksDashboard} />}
        />
      </Routes>
    </Router>
  </SessionProvider>
);

export default Navigation;
